import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import SearchableSelect from '../../../components/ui/SearchableSelect/SearchableSelect';
import { SELECT_MODE } from '../../../components/ui/SearchableSelect/constants';
import { USER_STATUS_FILTER_OPTIONS } from '../config/userStatusCopy';

export default function UserStatusFilterSelect({
  value,
  onChange,
  disabled = false,
  sx,
}) {
  return (
    <Box sx={sx}>
      <SearchableSelect
        mode={SELECT_MODE.STATIC}
        options={USER_STATUS_FILTER_OPTIONS}
        value={value}
        onChange={onChange}
        label="Status"
        labelKey="label"
        placeholder="All statuses"
        disabled={disabled}
        clearable
      />
    </Box>
  );
}

UserStatusFilterSelect.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
};
